import { combineReducers } from "redux";

export default combineReducers({
  mergeCms: require("./MergeCmsRedux").reducer,
});
